module.exports = __webpack_public_path__ + "img/scene-bg-4.bda8266a.png";